module.exports = __webpack_public_path__ + "static/media/HDE_Logo@2x.27712baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/infopanel/HDE_Logo@2x.png
// module id = 466
// module chunks = 0